export default __webpack_public_path__ + "static/media/d.15a05b04.mp4";